// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"184e06c0","377":"fdc827a0","621":"f064aecf","948":"b34c1b28"}[chunkId] + ".chunk.js";
};